export default "https://legacy.eskolare.com/images/social-call-to-action.png";